module.exports = __webpack_public_path__ + "static/img/keith.731db158.png";